import Plausible from "plausible-tracker";
import * as GPS from "../services/geolocation";
import { isBrowser } from "../env";

type TrackEvent = { [key: string]: string | number | boolean | null };

declare global {
  interface Window {
    dataLayer: Array<TrackEvent>
  }
}

function track(data: TrackEvent) {
  if (!isBrowser) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function watchGTM() {
  if (!isBrowser) {
    console.error(new Error("GTM called in non-browser environment"));
    return;
  }

  // GPS LOCATION
  GPS.gpsStatus.subscribe((status) => {
    const event = "location prompt response";

    switch (status) {
      case GPS.FAILED:
        track({ event, locationShared: "no" });
        break;

      case GPS.ACTIVE:
        track({ event, locationShared: "yes" });
        break;
    }
  });
}

export function watchPlausible(domain: string) {
  if (!isBrowser) {
    console.error(new Error("Plausible called in non-browser environment"));
    return;
  }

  const plausible = Plausible({ domain });

  plausible.enableAutoPageviews();

  // GPS LOCATION
  GPS.gpsStatus.subscribe((status) => {
    const event = "location prompt response";

    switch (status) {
      case GPS.FAILED:
        plausible.trackEvent(event, { props: { locationShared: "no" } });
        break;

      case GPS.ACTIVE:
        plausible.trackEvent(event, { props: { locationShared: "yes" } });
        break;
    }
  });
}
